import {h, Fragment} from "preact"
import { useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"
import Pagination from "./Pagination"
import Select from "./elements/Select"
import SelectPagination from "./elements/SelectPagination"

export default function BottomToolbar() {
    const { from, to, size, total, handleSizeChange, sizeOptions } = useSizeOptions(sizes, defaultConfig.serpSize)
    const options = sizeOptions.map(v => ({ value: v, label: `${v} items per page` }))?.reverse();

    // function addSelectedClass(e) {
    //     console.log(e.target);
    //     const optionsContainer = e.target.closest("ul.ns-list-unstyled");
    //     console.log(optionsContainer);
    //     if(optionsContainer){
    //         const allOptions = optionsContainer.querySelectorAll("li");
    //         allOptions.forEach(element => {
    //             element.classList.remove("ns-selected");
    //             e.target.classList.add("ns-selected");
    //         });
    //     }
    // }

    // console.log(sizeOptions, "sizeOptions");
    // console.log(options, "options");

    return (
        // ns-my-4 
        <div class="ns-mx-0">
            {/* ns-justify-content-center ns-justify-content-xs-between ns-my-2 ns-justify-content-between */}
            <div class="ns-d-flex ns-flex-column ns-flex-l-row ns-align-items-center ns-bottom-toolbar ns-flex-wrap ns-border-box ns-color-black ns-w-100 ns-p-2 ns-mx-0">
                <div class="ns-col-l-3 ns-text-align-center ns-text-align-l-left">
                    Showing <strong>{from} - {total < to ? total : to}</strong> of <strong>{total}</strong> items
                </div>
                <Pagination />
                {sizeOptions.length > 0 && (
                    <SelectPagination
                        value={size}
                        onClick={e => {
                            handleSizeChange(e.target.value);
                        }}
                        className="ns-selection-dropdown-size-menu"
                        options={options}
                        label={"Items per page"}
                    />
                )}
            </div>
        </div>
    )
}
